import('chart.js');

let ChartJs = (() => {

    let init = () => {
        //
    };

    return {
        init: init
    };
})();

export default ChartJs;
